import { styled } from "@mui/material/styles";

interface CellActionContainerProps {
  backgroundColor: string;
}
export const CellActionContainer = styled("div")(
  ({ backgroundColor }: CellActionContainerProps) => ({
    position: "absolute",
    right: "5px",
    top: "50%",
    height: "20px",
    transform: "translateY(-10px)",

    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor,

    cursor: "pointer",
  })
);
